"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSelect = exports.Select = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("./components");
const hooks_1 = require("./hooks");
const models_1 = require("./models");
const Select = (props) => {
    const { options, initSelectedValues } = props;
    // TODO: Fine a better way to default the type to either array or an object depending on the variant.
    const [selected, setSelected] = (0, react_1.useState)(initSelectedValues !== null && initSelectedValues !== void 0 ? initSelectedValues : []);
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const activeOptionsList = (0, react_1.useMemo)(() => {
        return options.filter((o) => !o.disabled);
    }, [options]);
    return (react_1.default.createElement(hooks_1.SelectProvider, { props: Object.assign(Object.assign({}, props), { activeOptionsList,
            selected,
            setSelected,
            expanded,
            setExpanded }) },
        react_1.default.createElement(components_1.SelectInput, null)));
};
exports.Select = Select;
const SearchSelect = (props) => {
    const { options, initSelectedValues, searchMode, showLoading = false, loadingText = "Loading options", } = props;
    const [selected, setSelected] = (0, react_1.useState)(initSelectedValues !== null && initSelectedValues !== void 0 ? initSelectedValues : []);
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const activeOptionsList = (0, react_1.useMemo)(() => {
        return options.filter((o) => !o.disabled);
    }, [options]);
    return (react_1.default.createElement(hooks_1.SelectProvider, { props: Object.assign(Object.assign({}, props), { activeOptionsList,
            selected,
            setSelected,
            expanded,
            setExpanded }) },
        react_1.default.createElement(components_1.SearchSelectInput, { searchMode: searchMode !== null && searchMode !== void 0 ? searchMode : models_1.SearchSelectMode.AllWords, showLoading: showLoading, loadingText: loadingText })));
};
exports.SearchSelect = SearchSelect;
//# sourceMappingURL=Select.js.map